<script setup lang="ts">
withDefaults(defineProps<{
  message?: string;
  href?: string;
  linkText?: string;
  variant?: "default" | "error";
}>(), {
  message: "Mint didn't work? Found a bug? Please report it.",
  href: "https://discord.com/channels/1281586674576654351/1333339771870904423",
  linkText: "Report an issue",
  variant: "default",
});
</script>

<template>

  <div
    class="flex items-center w-full sm:rounded-[4px] px-2 py-1"
    :class="variant === 'error' ? 'bg-red-700' : 'bg-indigo-600'">
    <span class="flex items-center w-full justify-center sm:justify-between text-white text-xs font-medium">
      <span>{{ message }}</span>
      <a
        class="underline hidden sm:block"
        :href="href"
        target="_blank">{{ linkText }}</a>
    </span>
  </div>

</template>
